var map = {
	"./anchorage.svg": 275,
	"./beach.svg": 276,
	"./boatramp.svg": 277,
	"./boatyard.svg": 278,
	"./bridge.svg": 778,
	"./businessspot.svg": 779,
	"./cave.svg": 279,
	"./fishing.svg": 780,
	"./inletcon.svg": 781,
	"./lockgate.svg": 782,
	"./marina.svg": 280,
	"./mooring.svg": 281,
	"./port.svg": 282,
	"./restricted.svg": 783,
	"./rock.svg": 784,
	"./seaplaneport.svg": 283,
	"./shipyard.svg": 284,
	"./transitional.svg": 785,
	"./wreck.svg": 285
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 777;